
import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { checkServerStatus } from '@/utils/serverStatus';

export const useServerStatus = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['serverStatus'],
    queryFn: checkServerStatus,
    refetchInterval: 30000, // Check every 30 seconds
  });

  return {
    isOnline: data?.isOnline || false,
    whatsappConnected: data?.whatsappConnected || false,
    telegramConnected: data?.telegramConnected || false,
    activeConnections: data?.activeConnections || 0,
    environment: data?.environment || 'unknown',
    timestamp: data?.timestamp || new Date().toISOString(),
    isLoading,
    error,
    refetch
  };
};
